/**
 * @file AddEditQueueDialog.jsx
 * @description AddEditQueueDialog component for displaying and managing add/edit queue dialog.
 * @component AddEditQueueDialog
 * @exports AddEditQueueDialog - Main component for displaying and managing add/edit queue dialog.
 */

import React from "react";
import InputAdornment from '@mui/material/InputAdornment';
import { Button, TextField, Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { QUEUE_STRINGS, QUEUE_KEYS } from "../../../common/constants/ivrModule/queueConstants.js";
import { STRINGS, SIZES, VARIANTS, BUTTON_COLORS, AUTO_COMPLETE } from "../../../common/constants/commonConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const AddEditQueueDialog = ({
    onSave,
    isEditQueue,
    ivrPolicies,
    selectedQueue,
    open,
    handleInputChange,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={isEditQueue ? QUEUE_STRINGS.EDIT_QUEUE : QUEUE_STRINGS.ADD_QUEUE}
                actions={
                    <Button
                        onClick={onSave}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.PRIMARY}
                    >
                        {STRINGS.SAVE}
                    </Button>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        disabled={isEditQueue}
                        variant={VARIANTS.OUTLINED}
                        label={QUEUE_STRINGS.POLICY_ID}
                        autoComplete={AUTO_COMPLETE.OFF}
                        onChange={handleInputChange(QUEUE_KEYS.ID)}
                        value={!isEditQueue ? (selectedQueue?.id?.replace(/^qu-*/, "") || "") : (selectedQueue?.id || "")}
                        slotProps={{
                            input: {
                                startAdornment: !isEditQueue ? (
                                    <InputAdornment position="start" sx={{ margin: 0, lineHeight: "normal" }}>
                                        qu-
                                    </InputAdornment>
                                ) : "",
                            },
                        }}
                    />
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        variant={VARIANTS.OUTLINED}
                        autoComplete={AUTO_COMPLETE.OFF}
                        label={QUEUE_STRINGS.QUEUE_NAME}
                        value={selectedQueue?.queuename || ""}
                        onChange={handleInputChange(QUEUE_KEYS.QUEUE_NAME)}
                    />
                    <FormControl fullWidth size={SIZES.SMALL}>
                        <InputLabel>{QUEUE_STRINGS.QUEUE_POLICY}</InputLabel>
                        <Select
                            label={QUEUE_STRINGS.QUEUE_POLICY}
                            value={selectedQueue?.distributionPolicyId || ""}
                            onChange={handleInputChange(QUEUE_KEYS.DISTRIBUTION_POLICY_ID)}
                        >
                            {ivrPolicies.map((ivrPolicy) => (
                                <MenuItem key={ivrPolicy.id} value={ivrPolicy.id}>
                                    {ivrPolicy.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogComponent>
        </>
    )
};

export default AddEditQueueDialog;